import {
  exception
} from '../../util/decorators'
import BaseApi from './BaseApi'

export default class MovieApi extends BaseApi {
  @exception('获取影片列表失败')
  getPage(params) {
    return this.httpJsonp('/movie/lists', params)
  }

  @exception('获取影片详情失败')
  getDetail(params) {
    return this.httpGet('/movie/index', params)
  }

  @exception('获取视频资源失败')
  getResource(params) {
    return this.httpGet('/url/index', params)
  }

  @exception('获取影片列表失败')
  getTops() {
    return this.httpJsonp('/movie/tops', {})
  }
}



// WEBPACK FOOTER //
// ./src/service/api/MovieApi.js